import Button from '@components/v2/ui/Button/Button';
import Typography from '@components/v2/ui/Typography/Typography';
import { Grid } from '@mui/material';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useShallow } from 'zustand/react/shallow';
import LangEnum from '../../lang/LangEnum';
import useOrderBookStore from '../../stores/OrderBook/orderBook.store';
import { OrderBookStateEnum } from '../../stores/OrderBook/orderBook.types';
import { ActiveOrderTestIds } from '../../utils/testIds/ActiveOrder.testIds';
import { useApplicationContext } from '../context/ApplicationContext/ApplicationContext';
import useProductDetailsActions from '../products/products-details-v2/hooks/useProductsDetailsActions';
import { useTranslation } from '../translation/TranslationContext';
import OrderAutocomplete from './OrderAutocomplete';
import { useOrderBookStyles } from './styles/OrderBookStyles';

const EmptyOrderFooter: React.FC = () => {
  const { translate } = useTranslation();
  const { team, isStore } = useApplicationContext();
  const { verifyProductDetailsModalOpenedByOrderBook } = useProductDetailsActions();
  const history = useHistory();
  const [
    orderAutocompleteFocused,
    handleChangeOrderBookTimeline,
    createOrder,
    customer,
    loadingOrder,
    loadingOrderItems,
  ] = useOrderBookStore(
    useShallow((state) => [
      state.orderAutocompleteFocused,
      state.handleChangeOrderBookTimeline,
      state.createOrder,
      state.customer,
      state.loadingOrder,
      state.loadingOrderItems,
    ]),
  );
  const isLoading = loadingOrderItems || loadingOrder;
  const { classes } = useOrderBookStyles();

  const handleCreateNewOrder = () => {
    if (isStore) {
      createOrder({
        history,
        team,
        customerId: customer?.id,
        translate,
        onSuccess: verifyProductDetailsModalOpenedByOrderBook,
      });
    } else {
      handleChangeOrderBookTimeline(OrderBookStateEnum.SEARCH_CUSTOMER);
    }
  };

  return (
    <Grid container>
      <Grid className={classes.footerTitleContainer} size={11}>
        <Typography variant="overline" color="textSecondary" gutterBottom>
          {translate(LangEnum.ORDER_BOOK_ADD_ORDERS)}
        </Typography>
      </Grid>
      <Grid size={12}>
        <Grid
          container
          spacing={1}
          sx={{
            justifyContent: 'space-around',
            alignItems: 'center',
          }}
        >
          <Grid size={orderAutocompleteFocused ? 12 : 'grow'}>
            <OrderAutocomplete />
          </Grid>
          {!orderAutocompleteFocused && (
            <Grid>
              <Button
                fullWidth
                size="large"
                testId={ActiveOrderTestIds.ORDER_SELECTED_BUTTON}
                color="primary"
                variant="contained"
                loading={isLoading}
                onClick={handleCreateNewOrder}
                sx={(theme) => ({
                  borderRadius: theme.shape.borderRadiusFull,
                })}
              >
                {translate(LangEnum.GLOBAL_NEW_ORDER)}
              </Button>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default EmptyOrderFooter;
